import dayjs from 'dayjs'

import { type VisaBulletinFilingDateType, type VisaBulletinFinalActionDateType } from '../queries/types'
import { type VisaBulletinDate } from '../types/visa-bulletin'

export const toVisaBulletinDate = (dateString: string): VisaBulletinDate => {
  if (!dateString) {
    return null
  }

  if (dateString === 'current') {
    return 'current'
  }

  if (dateString === 'unauthorized') {
    return 'unauthorized'
  }

  return dayjs.utc(dateString)
}

export const renderVisaBulletinDate = (
  dateString: string | number | null | undefined,
  type: VisaBulletinFilingDateType | VisaBulletinFinalActionDateType
): string => {
  if (type === 'C') {
    return 'Current'
  }

  if (type === 'U') {
    return 'Unavailable'
  }

  if (!dateString) {
    return '-'
  }

  return dayjs.utc(dateString).format('MMM D, YYYY')
}
